"use client"
import { create } from "zustand"
import { AnalyzeResponse } from "../_fetch/fetchClientBookShelfAnalyze"

interface BookAnalysisState {
  currentAnalysis: AnalyzeResponse | null
  isAnalyzing: boolean
  analysisError: string | null
  
  // Actions
  setCurrentAnalysis: (analysis: AnalyzeResponse | null) => void
  setIsAnalyzing: (analyzing: boolean) => void
  setAnalysisError: (error: string | null) => void
  clearAnalysis: () => void
}

export const useBookAnalysisStore = create<BookAnalysisState>((set) => ({
  currentAnalysis: null,
  isAnalyzing: false,
  analysisError: null,

  setCurrentAnalysis: (analysis) => set({ currentAnalysis: analysis }),
  setIsAnalyzing: (analyzing) => set({ isAnalyzing: analyzing }),
  setAnalysisError: (error) => set({ analysisError: error }),
  clearAnalysis: () => set({ 
    currentAnalysis: null, 
    isAnalyzing: false, 
    analysisError: null 
  }),
}))